module.exports = __webpack_public_path__ + "img/status_3.6f68ad64.png";